import React, { useEffect, useState } from "react";
import "../../css/Home/mainNoticePopup.css";

const POPUP_ID = "disney-maintenance-20260812-v1";
const DISPLAY_UNTIL = new Date("2026-08-12T19:00:00+09:00").getTime();

function isDisplayPeriod() {
  return Date.now() < DISPLAY_UNTIL;
}

function buildStorageKey(storageScope) {
  return `${storageScope}:hidden:${POPUP_ID}`;
}

function isPopupHidden(storageScope) {
  if (typeof window === "undefined") return true;

  try {
    return window.localStorage.getItem(buildStorageKey(storageScope)) === "1";
  } catch (_) {
    return false;
  }
}

function hidePopupPermanently(storageScope) {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(buildStorageKey(storageScope), "1");
  } catch (_) {
    // Storage can be unavailable in restricted browser modes. Closing still works.
  }
}

export default function MainNoticePopup({ storageScope = "mainPopup" }) {
  const [isOpen, setIsOpen] = useState(() => isDisplayPeriod() && !isPopupHidden(storageScope));

  useEffect(() => {
    setIsOpen(isDisplayPeriod() && !isPopupHidden(storageScope));
  }, [storageScope]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDontShowAgain = () => {
    hidePopupPermanently(storageScope);
    setIsOpen(false);
  };

  return (
    <div
      className="main-notice-popup-backdrop"
      role="presentation"
      onMouseDown={() => setIsOpen(false)}
    >
      <section
        className="main-notice-popup"
        role="dialog"
        aria-modal="true"
        aria-labelledby="main-notice-popup-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="main-notice-popup-close"
          aria-label="팝업 닫기"
          onClick={() => setIsOpen(false)}
        >
          ×
        </button>

        <div className="main-notice-popup-header">
          <span className="main-notice-popup-badge">중요공지</span>
          <h2 id="main-notice-popup-title">디즈니 크루즈 예약 시스템 점검 안내</h2>
        </div>

        <div className="main-notice-popup-body">
          <dl className="main-notice-popup-schedule">
            <div>
              <dt>점검 시작</dt>
              <dd>2026년 8월 12일(수) 오후 1시 (한국 시간)</dd>
            </div>
            <div>
              <dt>점검 종료</dt>
              <dd>2026년 8월 12일(수) 오후 7시 (한국 시간)</dd>
            </div>
          </dl>

          <p>
            디즈니 크루즈 라인의 예약 시스템 정기 점검으로 인해 아래 시간 동안
            예약 및 일부 서비스 이용이 일시 중단됩니다.
          </p>

          <ul>
            <li>디즈니 크루즈 신규 예약 및 예약 변경</li>
            <li>DCL Navigator 앱의 승선 전 일부 기능</li>
          </ul>

          <p>
            점검 시간에는 예약 조회 및 변경 처리가 원활하지 않을 수 있으므로,
            관련 업무는 점검 시간 전후에 이용해 주시기 바랍니다.
          </p>

          <p>
            서비스는 8월 12일 오후 7시 이후 정상화될 예정입니다.
          </p>

          <p>
            이용에 불편을 드려 죄송하며, 고객님의 양해 부탁드립니다.
          </p>
        </div>

        <div className="main-notice-popup-footer">
          <button
            type="button"
            className="main-notice-popup-secondary"
            onClick={handleDontShowAgain}
          >
            다시 안보기
          </button>
          <button
            type="button"
            className="main-notice-popup-primary"
            onClick={() => setIsOpen(false)}
          >
            닫기
          </button>
        </div>
      </section>
    </div>
  );
}
